import Vue from 'vue'
import Vuex from 'vuex'
import VueScrollTo from 'vue-scrollto'

// import { SCORM } from 'pipwerks-scorm-api-wrapper'

Vue.use(Vuex)
Vue.use(VueScrollTo)

export default new Vuex.Store({
  state: {
    currentLocation: 0,
    totalPages: 26,
    menuItems: [
    ]
  },
  mutations: {
    /**
     * Update current location if the clicked button is higher than the current page count
     */
    showNext (state, n) {
      if (n >= state.currentLocation) {
        state.currentLocation = n
      }
    },

    /**
     * Update current location if the clicked button is higher than the current page count
     */
    changeMenuStatus (state) {
      for (let i = 0; i < state.menuItems.length; i++) {
        const el = state.menuItems[i]
        if (state.currentLocation > el.activeLocation) {
          el.sideMenuIcon = 'menu-status_complete.png'
        }
      }
    }
  },
  actions: {
    showNext (context, obj) {
      context.commit('showNext', obj.n)
      context.commit('changeMenuStatus')

      setTimeout(() => {
        VueScrollTo.scrollTo(obj.el, { offset: 30 })
        console.log(obj.el)
      }, 100)

      // Store currentLocation
      if (obj.n >= this.state.currentLocation) {
        localStorage.setItem('m3-fr-currentLocation', Math.ceil(obj.n))
      }
      localStorage.setItem('m3-fr-lastSavedPosition', obj.el)
    },
    initCourse (context) {
      context.commit('showNext', localStorage.getItem('m3-fr-currentLocation'))

      if (localStorage.getItem('m3-fr-currentLocation') >= 26) {
        return
      }

      setTimeout(() => {
        VueScrollTo.scrollTo(localStorage.getItem('m3-fr-lastSavedPosition'), { offset: 30 })
      }, 100)
    }
  }
})
